var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "top-bar" }, [
    !_vm.downloading && !_vm.pickingColor
      ? _c("img", {
          staticClass: "top-bar__logo",
          attrs: { src: "/brawlstars_logo.png", alt: "Brawl Stars Logo" },
        })
      : _vm._e(),
    !_vm.downloading && !_vm.interacting
      ? _c(
          "div",
          {
            staticClass: "top-bar__actions",
            style: `transform: scale(${_vm.controlsScale}); transform-origin: top right;`,
          },
          [
            _c("DownloadButton", {
              attrs: { size: _vm.buttonSize },
              nativeOn: {
                click: function ($event) {
                  return _vm.finishEditingDownload(true)
                },
              },
            }),
            _c("UploadButton", {
              attrs: { size: _vm.buttonSize },
              nativeOn: {
                click: function ($event) {
                  return _vm.finishEditingUpload(true)
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.downloading
      ? _c(
          "div",
          { staticClass: "top-bar__back" },
          [
            _c("BackButton", {
              nativeOn: {
                click: function ($event) {
                  return _vm.finishEditingDownload(false)
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "top-bar__tooltip" },
      [
        _c("Tooltip", { attrs: { opened: _vm.uploadTooltip } }, [
          _c("p", {
            staticClass: "top-bar__tooltipText",
            domProps: { textContent: _vm._s(_vm.$t("gen_tooltip")) },
          }),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }